import {
	IconPassport,
	IconPerson,
	IconTime,
	IconTimelineStop,
} from '@flixbus/honeycomb-icons-react';

import { CREATE_BREAKDOWN_FLOW_TEXT } from 'pages/WorkAssignments/components/CreateBreakdownFlow/texts';
import { formatSummaryDateTime } from 'utils/datetime/fnsTimeFormatter';

import { BREAKDOWN_DETAILS_MODAL_TEXT } from '../text';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;
const ORIGINAL_DRIVER_ANNOTATION = CREATE_BREAKDOWN_FLOW_TEXT.summary.originalDriverAnnotation;

/**
 * Build the "Cushioning parameters" rows from an accepted breakdown.
 *
 * Driver name receives a " (original driver)" annotation when the breakdown
 * does not have a parallel ride — mirroring the design across Bus failure +
 * Deadhead and Driver out of hours flows. In parallel variants the plain
 * name is shown. `outboundTravelingWorkAssignment.crewMember` is trusted as
 * the source of truth: whichever driver BE persists there is what we show.
 *
 * @param {object} breakdown
 * @returns {import('common/BreakdownDetails').BreakdownDetailsRow[]}
 */
export const deriveCushioningRowsFromBreakdown = (breakdown) => {
	const outbound = breakdown?.outboundTravelingWorkAssignment;
	if (!outbound) return [];

	const driver = outbound.crewMember;
	const isParallel = breakdown?.parallelRide != null;
	const shouldAnnotate = driver?.fullName && !isParallel;
	const nameValue = driver?.fullName ?? '';
	const annotatedNameValue = shouldAnnotate
		? `${nameValue} ${ORIGINAL_DRIVER_ANNOTATION}`
		: nameValue;

	return [
		{
			label: LABELS.driverName,
			value: annotatedNameValue,
			icon: IconPerson,
		},
		{
			label: LABELS.driverId,
			value: driver?.driverCard ?? BREAKDOWN_DETAILS_MODAL_TEXT.notAvailable,
			icon: IconPassport,
		},
		{
			label: LABELS.cushioningStart,
			value: formatSummaryDateTime(outbound.fromTimestamp),
			icon: IconTime,
		},
		{
			label: LABELS.cushioningEnd,
			value: formatSummaryDateTime(outbound.toTimestamp),
			icon: IconTimelineStop,
		},
	];
};
